<template>
 
  <section class="h-full bg-purple-600 bg-gradient-to-t from-purple-600 via-purple-500 to-purple-600 rounded-xl py-4 flex flex-col space-y-3 lg:space-y-4">
  
    <div ref="mainContainer" class="overflow-x-hidden overflow-y-auto white-small-scroll h-full direction-rtl w-11/12 mx-auto md:w-full pl-4 space-y-2" >

      <div class="relative direction-ltr w-full mr-2">
        <transition name="pop"> 
        <div v-if="isAsideExpanded" class="text-white flex space-x-2 p-2 border border-white border-opacity-80 rounded-xl select-none hover:bg-purple-500 pop-click" @click="$emit('createChatRoom')">
          <ion-icon class="text-xl lg:text-2xl flex-shrink-0" name="add-circle"></ion-icon>
          <h6  class="text-sm md:text-xs lg:text-sm table my-auto">Create Chat Room</h6>
        </div>
        <div v-else @click="$emit('createChatRoom')" class="w-max text-white text-3xl bg-purple-400 p-3 rounded-full flex pop-click  transition-all bg-opacity-50 hover:bg-opacity-100 mx-auto">
          <ion-icon class="m-auto" name="add-circle"></ion-icon>
        </div>
        </transition>
      </div>
    
      <div class="relative direction-ltr w-full mr-2">
        <transition name="pop"> 
        <div v-if="isAsideExpanded" class="text-white flex space-x-2 p-2 border border-white border-opacity-80 rounded-xl select-none hover:bg-purple-500 pop-click cursor-text" @click="toggleSearchChat(true)">
          <ion-icon class="text-xl lg:text-2xl flex-shrink-0" name="search-outline"></ion-icon>
          <h6  class="text-sm md:text-xs lg:text-sm table my-auto">Search Chat Room</h6>
        </div>
        <div v-else @click="toggleSearchChat(true)" class="w-max text-white text-3xl bg-purple-400 p-2 rounded-full flex pop-click  transition-all bg-opacity-50 hover:bg-opacity-100 mx-auto">
          <ion-icon class="m-auto" name="search-circle"></ion-icon>
        </div>
        </transition>
      </div>

      <transition-group id="tabContainer" tag="div" name="slide-up" class="flex flex-col space-y-2 direction-ltr pb-2 mr-2 w-full"  >
        <section  v-for="(chat,key) in sortedUsersChatRoom" :key="key" class="relative">

            <transition name="pop"> 
            <div v-if="isAsideExpanded"  @click="setCurrentChatRoom(key)" class=" p-3 md:p-2 lg:p-3 flex transition-colors  bg-white overflow-hidden  space-x-1 " :style="getBorderActiveStyle(key)" :class="[ key === this.currentOpenedChatRoom.id && isAtLargeScreen ? 'cursor-default active:scale-100 -mr-2' : '','pop-click mr-0']">

            <div class="h-full my-auto">
              <div class="my-auto w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden pop-click relative"  >
                  <img class="w-full h-full min-w-full min-h-full absolute  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="chat.icon" :alt="chat.name" @error="$emit('errorIcon',key)">
              </div>
            </div>
            
            <div  class="flex flex-col select-none justify-center text-purple-600"  :class="{ 'font-bold' : roomsWithUnseenMessages[key] }">
              <h4 class="text-sm font-medium xl:text-base line-clamp-1 text-purple-500"> {{ chat.name }} </h4>
              <div v-if="chat.recent" class="flex space-x-1 text-xs w-full ">
                <h6 class="flex-grow line-clamp-1"> 
                  <span v-if="chat.recent.sender"> 
                    <span v-if="chat.recent.sender.id !== this.currentUsersData.uid"> {{ chat.recent.sender.username }} </span> 
                    <span v-else>You</span>  
                  </span>
                  <span class="w-10/12 ">
                  {{  ' : ' + chat.recent.message }}    
                  </span>  
                  </h6>
                <span class="flex-none">•</span>
                <h6 class="flex-none"> {{ chat.recent.dateGapFromNow }} </h6>
              </div>
            </div>

            </div>
            <div v-else>
              <div @click="setCurrentChatRoom(key)" class="w-max text-white  p-2 transition-all bg-opacity-50 hover:bg-opacity-100 mx-auto rounded-full" :class="[{ 'cursor-default active:scale-100 w-full bg-pink-500' : key === this.currentOpenedChatRoom.id },'pop-click bg-purple-400']">
                  <div class="w-6 md:w-8 lg:w-10  h-6 md:h-8 lg:h-10 mx-auto rounded-full overflow-hidden">
                  <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  transition-all select-none z-10" :src="chat.icon" :alt="chat.name" @error="$emit('errorIcon',key)">
                </div>    
              </div>
              
            </div>
            </transition>
        </section> 
      </transition-group>
      <google-loader v-if="isAddingSideChatRoom" widthClass="w-12 py-4"></google-loader>
      <div class="-ml-4 text-center text-purple-200 text-xs">
        <span>End</span><span v-if="isAsideExpanded"> of Result</span>
      </div>
    </div>

    <div v-if="isAtLargeScreen" @click="$emit('toggleIsAsideExpanded')" class="absolute bottom-10 text-white text-lg bg-purple-500 p-2 flex mx-1 pop-click  transition-all bg-opacity-80 hover:bg-opacity-100 duration-500 rounded-full w-12" :class="asideExpandRotation" title="Expand/Shrink Side Navigation" >
      <img src="/button-icons/side-chat.svg">
    </div>
  
  </section>

  <tab-container tabName="Search your Chat Room" :isTabOpened="searchChat.isVisible" @toggleTab="(toOpen)=>{toggleSearchChat(toOpen)}" @opened="focusOnSearchInput">
    <section class="max-w-md mx-auto">
      <input ref="searchRoomInput" type="search" v-model="searchChat.queryString" class="text-input-default" placeholder="Search Chat Room">

      <div v-if="searchChat.queryString === ''" class="bg-white shadow-2xl rounded-b-xl p-2 divide-y-2 divide-gray-100 text-gray-500 text-base">
        <div v-for="(query,key) in searchHistories.queries" :key="key" @click="searchChat.queryString = query" class="p-2 hover:bg-gray-200 cursor-pointer rounded-md pop-click">
          <h6>{{query}}</h6>
        </div>
        <h6 v-if="searchHistories.queries && searchHistories.queries.length < searchHistories.maxQuery" @click="getSearchHistory(searchHistories.limit + searchHistories.addPerLoad)" class="text-xs text-gray-300 hover:underline text-center cursor-pointer w-max mx-auto">View More</h6>
      </div>

      <div>
        <transition-group tag="div" name="slide-up" class="flex flex-col space-y-2 w-full my-5">
          
          <section  v-for="(chat,key) in  searchChat.queryResult" :key="key" class="relative">
            <div v-if="chatRoomsIdList.includes(key)" @click="setCurrentChatRoom(key,true)" class=" p-3 md:p-2 lg:p-3 flex transition-colors  bg-purple-500 overflow-hidden  space-x-1 rounded-xl hover:bg-purple-600 pop-click">

            <div class="h-full my-auto">
              <div class="my-auto w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden pop-click relative">
                  <img class="w-full h-full min-w-full min-h-full absolute  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="chat.icon" :alt="chat.name" @error="$emit('errorIcon',key)">
              </div>
            </div>
            
            <div  class="flex flex-col select-none justify-center text-white mx-2" >
              <h4 class="text-sm font-medium xl:text-base line-clamp-1"> {{ chat.name }} </h4>
            </div>
            </div>
          </section>
  
        </transition-group>
      </div>
    </section>
  </tab-container>

</template>

<script>
import GoogleLoader from '@/components/GoogleLoader.vue';
import TabContainer from '@/components/TabContainer.vue';
import firebase from "firebase/app";

export default {
  data(){
    return {
      searchHistories : {
        queries : null,
        limit : 5,
        addPerLoad : 10,
        maxQuery : -1
      },
      searchChat : {
        isVisible : false,
        queryString : "",
        queryResult : {}
      },
      isAddingChatRoom : false,
      isTargetingChatRoom : false,
      roomsWithUnseenMessages : {},
      toAvoidChatRoomIds : [],
    }
  },
  components : {
    'google-loader' : GoogleLoader,
    'tab-container' : TabContainer
  },
  props : {
    chatRoomsId : Object,
    usersChatRoom : Object,
    isAsideExpanded : Boolean,
    isDiscoverExpanded : Boolean,
    currentOpenedChatRoom : Object,
    currentUsersData : Object,
    isAtLargeScreen : Boolean,
    previousOpenedChatId : String,
    maxChatRooms : Number,
    isAddingSideChatRoom : Boolean,
    sideChatRoomLimit  : {
      type : Number,
      default : 0
    }
  },
  emits: ['errorIcon','toggleIsAsideExpanded','setCurrentChatRoom','createChatRoom','bottomScrolled'],
  mounted() {
    this.$refs.mainContainer.addEventListener("scroll", this.checkIfOnBottom)
  },
  beforeUnmount(){
    this.$refs.mainContainer.removeEventListener("scroll", this.checkIfOnBottom);
  },
  computed : {
    chatRoomsIdList(){
      return Object.keys(this.chatRoomsId);
    },
    searchRoomWord(){
      return this.searchChat.queryString;
    },
    asideExpandRotation(){
      return {
      'rotate-0' : this.isAsideExpanded,
      'rotate-180' : !this.isAsideExpanded
      }
    },
    sortedUsersChatRoom(){
      const sorted = Object.fromEntries(
          Object.entries(this.usersChatRoom).sort(([,a],[,b]) => {
            var dateA = 0; 
            var dateB = 0;
            if(a.recent)dateA = a.recent.date;
            if(b.recent)dateB = b.recent.date;
            return  dateB - dateA;
          })
      );
      return sorted;
    },
    sortedUsersChatRoomIds(){
      return Object.keys(this.sortedUsersChatRoom);
    },
    sortedUsersChatRoomLength(){
      return this.sortedUsersChatRoomIds.length;
    },
    computedSideChatRoomLimit(){
      //this computed value will fix bug that cant target chatroom when max chat room is lower then chat room limit
      if(this.maxChatRooms < this.sideChatRoomLimit)return this.maxChatRooms;
      return this.sideChatRoomLimit;
    },
    isSearchVisible(){
      return this.searchChat.isVisible;
    }
  },
  methods : {
    focusOnSearchInput(){
      setTimeout(()=>{
        if(this.$refs.searchRoomInput)this.$refs.searchRoomInput.focus();
      }, 1000);
    },
    getSearchHistory(limit  = 5){
      this.searchHistories.queries = [];
      const searchHistory = firebase.database().ref('users').child(this.currentUsersData.uid).child('searchHistory');

      searchHistory.orderByChild('date').limitToLast(limit)
      .on('value',(snapshot) => {
        this.searchHistories.queries = [];
         snapshot.forEach((childSnapshot) => {
           this.searchHistories.queries.unshift(childSnapshot.val().query);
         })
      });
      this.searchHistories.limit = limit;
      
      if(this.searchHistories.maxQuery === -1)searchHistory.on('value',(snapshot) => {this.searchHistories.maxQuery = snapshot.numChildren();});
    },
    toggleSearchChat(isVisible = null){
      if(isVisible === null)return this.searchChat.isVisible = !this.searchChat.isVisible;
      this.searchChat.isVisible = isVisible;
      if(isVisible && this.searchHistories.queries === null)this.getSearchHistory();
    },
    searchChatRoom(queryText){
      if(queryText === "")return this.searchChat.queryResult = {};
      queryText = queryText.toLowerCase();
      firebase.database().ref('chatRooms').orderByChild('nameSearch')
      .startAt(queryText)
      .endAt(queryText+"\uf8ff")
      .on("value", (snapshot)=> {
        this.searchChat.queryResult = snapshot.val();
      });
    },
    getBorderActiveStyle(key){
      const defaultBorder = '-webkit-border-radius: 1rem;-moz-border-radius:1rem;border-radius: 1rem;';
      if(!key || !this.isAtLargeScreen)return defaultBorder;
      if(key === this.currentOpenedChatRoom.id)return '-webkit-border-radius: 1rem 0 0 1rem;-moz-border-radius:1rem 0 0 1rem;border-radius: 1rem 0 0 1rem;';
      return defaultBorder;
    },
    checkIfOnBottom() {
      if(this.isAddingChatRoom)return;
      const mainContainer = this.$refs.mainContainer;
      const tabContainer = document.getElementById('tabContainer');
      // console.log( mainContainer.offsetHeight, tabContainer.offsetHeight );
      if ((mainContainer.offsetHeight + mainContainer.scrollTop) >= (tabContainer.offsetHeight) ) {
        this.isAddingChatRoom = true;
        this.$emit('bottomScrolled');
      }
      
    },
    setCurrentChatRoom(chatRoomId,isFromSearch = false){
      if(isFromSearch){
        const stringHistory = this.searchChat.queryString;
        firebase.database().ref('users').child(this.currentUsersData.uid).child('searchHistory').child(stringHistory.toLowerCase()).set({
          query : stringHistory,
          date : Date.now()
        })
        this.searchChat = {
          isVisible : false,
          queryString : "",
          queryResult : {}
        }
      }
      this.isTargetingChatRoom = true;
      if(!chatRoomId)return;
      this.triggerNotif(chatRoomId,false);
      if(chatRoomId === this.currentOpenedChatRoom.id)return;
      this.$emit('setCurrentChatRoom',chatRoomId);
      this.isTargetingChatRoom = false;

    },
    triggerNotif(chatRoomId,trigger = true){
      if(!trigger)return this.roomsWithUnseenMessages[chatRoomId] = false;
      if(!chatRoomId)return;
      if(this.roomsWithUnseenMessages[chatRoomId])return;
      if(chatRoomId === this.currentOpenedChatRoom.id)return;
      this.roomsWithUnseenMessages[chatRoomId] = true;
    },
    setCurrentChatRoomToMostRecent(isLeaved = false){
      //this function will also be called by Home.vue for transitioning from small device to large device
      let mostRecentIndex = this.sortedUsersChatRoomIds.length - 1;
      if(isLeaved)mostRecentIndex = 0;
      this.setCurrentChatRoom(this.sortedUsersChatRoomIds[mostRecentIndex]);
    }
  },
  watch : {
    searchRoomWord(word){
      this.searchChatRoom(word);
    },
    sortedUsersChatRoomLength : {
      immediate : true,
      handler(length){
        if(length === this.maxChatRooms){
          if(length === 1 && this.isAtLargeScreen)this.setCurrentChatRoomToMostRecent();    
          if(this.$refs.mainContainer)this.$refs.mainContainer.removeEventListener("scroll", this.checkIfOnBottom);
        }
        if(this.isTargetingChatRoom)return;
        if(length < this.computedSideChatRoomLimit && this.computedSideChatRoomLimit > 1)return;
        this.isTargetingChatRoom = true;
        this.isAddingChatRoom = false;
        if(this.isAtLargeScreen)this.setCurrentChatRoomToMostRecent();
        
      }
    },
  }
}  
</script>
